import { useCallback, useEffect, useState } from "react"
import { getData, removeDataById } from "../../api/userData"
import { Grid } from "antd-mobile"
import { DeleteOutline } from "antd-mobile-icons"

function MyDiet() {
  const [diet, setDiet] = useState([])

  const refreshData = () => {
    const data = getData("diet")?.value || []
    console.log(data);
    setDiet(data) 
  }

  useEffect(() => {
    refreshData()
  }, [])

  const onDelete = useCallback((id) => {
    removeDataById("diet", id)
    refreshData();
  }, [])

  return (
    <Grid
      columns={12}
      gap={12}
      style={{
        marginLeft: 16,
        marginRight: 16,
        width: "100%",
        height: "calc(100vh - 120px)",
      }}
    >
      <Grid.Item span={12}>
        <p>Мой рацион:</p>

        {diet.map((data, index) => {
          const [name, cal, fat, prot, carb] = String(data.name).split("|")
          return (
            <div
              key={`list-${index}`}
              style={{
                paddingTop: 10,
                paddingBottom: 10,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ paddingRight: 20 }}>
                <div style={{ fontSize: 16 }}>{name}</div>
                <div style={{ fontSize: 14 }}>
                  {cal} ккал, ЖБУ ({fat}, {prot} , {carb})
                </div>
              </div>
              <div style={{ paddingRight: 4 }}>
                <DeleteOutline
                  color="red"
                  fontSize={20}
                  onClick={() => onDelete(data.id)}
                />
              </div>
            </div>
          )
        })}
      </Grid.Item>
    </Grid>
  )
}

export default MyDiet
